export default "/_next/static/9c76502b1a83b02845368d713dff7f1f.png";